type EnvName = "local" | "staging" | "production";
export const getEnvName = (): EnvName => {
  return process.env.REACT_APP_ENV_NAME as EnvName;
};
